//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- FUNÇÃO ASSÍNCRONA SALVAR EMPRESA ---------------//
// Responsável por salvar a empresa criada via API
export default async function deleteTagService(id) {
    try {
        await api.delete(`/tags/${id}`);
        toast.success("Tag deletada com sucesso");
        return true;
    } catch {
        toast.error("Erro ao deletar tag");
        return false;
    }
}